import { useCallback } from 'react';
import type { JSX } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import type { LandingPageSlug } from 'src/app/pages/landing/template/shared/types';

import { trackLandingPageCtaClick } from '../api/track';
import { useTrackView } from '../hooks/track';

import { Body } from './Body';
import { Footer } from './Footer';
import { FooterCta } from './FooterCta';
import { Header } from './Header';

type Props = {
	slug: LandingPageSlug;
};

export function RenderTemplate({ slug }: Props): JSX.Element | null {
	const track = useTracking();
	useTrackView(slug);

	const onCtaClick = useCallback(async () => trackLandingPageCtaClick(slug, track), [slug, track]);

	return (
		<>
			<Header slug={slug} onCtaClick={onCtaClick} />
			<Body slug={slug} onCtaClick={onCtaClick} />
			<Footer slug={slug} />
			<FooterCta slug={slug} onCtaClick={onCtaClick} />
		</>
	);
}
